import { resolveAceleresApiBase } from 'shared/helpers/aceleresApiBase';

let sessionPromise = null;

const readChatwootSessionInfo = () => {
  try {
    const match = document.cookie.match(/(?:^|;)\s*cw_d_session_info=([^;]*)/);
    if (!match) return null;

    const info = JSON.parse(decodeURIComponent(match[1]));
    if (!info?.['access-token'] || !info?.client || !info?.uid) return null;

    return info;
  } catch {
    return null;
  }
};

const ensureAceleresSession = async () => {
  if (sessionPromise) return sessionPromise;

  sessionPromise = (async () => {
    const info = readChatwootSessionInfo();
    if (!info) return false;

    const body = new URLSearchParams({
      access_token: info['access-token'],
      client: info.client,
      uid: info.uid,
    });
    const response = await fetch(
      `${resolveAceleresApiBase()}/api/kanban/zoraxy-login`,
      {
        method: 'POST',
        credentials: 'include',
        headers: { Accept: 'application/json' },
        body,
      }
    );
    const data = await response.json().catch(() => ({}));

    return response.ok && data?.success === true;
  })()
    .catch(() => false)
    .finally(() => {
      sessionPromise = null;
    });

  return sessionPromise;
};

const request = async (path, options = {}, retrying = false) => {
  const response = await fetch(`${resolveAceleresApiBase()}${path}`, {
    credentials: 'include',
    cache: 'no-store',
    ...options,
    headers: {
      Accept: 'application/json',
      ...options.headers,
    },
  });
  const data = await response.json().catch(() => ({}));

  if (response.status === 401 && !retrying && (await ensureAceleresSession())) {
    return request(path, options, true);
  }

  if (!response.ok || data?.success !== true) {
    throw new Error(
      data?.message || 'Não foi possível carregar os follow-ups.'
    );
  }

  return data;
};

export default {
  async index() {
    const pageSize = 100;
    const notifications = [];
    const seenTaskIds = new Set();
    let offset = 0;
    let hasMore = true;

    while (hasMore) {
      // O próximo offset só pode ser definido após a resposta desta página.
      // eslint-disable-next-line no-await-in-loop
      const page = await request(
        `/api/followups?limit=${pageSize}&offset=${offset}`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ _operation: 'index' }),
        }
      );
      (page.items || []).forEach(item => {
        const taskId = item.task_id || item.id;
        if (!seenTaskIds.has(taskId)) {
          notifications.push(item);
          seenTaskIds.add(taskId);
        }
      });
      hasMore = Boolean(page.has_more);
      offset += pageSize;
    }

    return {
      items: notifications,
      unread_count: notifications.filter(
        notification => notification.has_notification && !notification.read_at
      ).length,
    };
  },

  markAsRead(id) {
    return request(`/api/notifications/${encodeURIComponent(id)}/read`, {
      method: 'POST',
    });
  },

  markAsUnread(id) {
    return request(`/api/notifications/${encodeURIComponent(id)}/unread`, {
      method: 'POST',
    });
  },

  complete(taskId) {
    return request('/api/followups', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ _operation: 'complete', task_id: taskId }),
    });
  },

  cancel(taskId) {
    return request('/api/followups', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ _operation: 'cancel', task_id: taskId }),
    });
  },

  delete(id) {
    return request(`/api/notifications/${encodeURIComponent(id)}/dismiss`, {
      method: 'DELETE',
    });
  },
};
